export const PscRoutes = {
    GetPscThumbnailZipFile: "Psc/GetPscThumbnailZipFile",
    GetPscCloseOutDocumentLinks: "Psc/GetPscCloseOutDocumentLinks"
}